module.exports = __webpack_public_path__ + "img/logo-wordmark.e9661a35.svg";